import { ImportStatusResponse } from '@epi-models/pages/MassUpload';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

type BeneficiariesImportState = {
  lastImportRequestId: number | null;
  importStatus: ImportStatusResponse | null;
};

const initialState: BeneficiariesImportState = {
  lastImportRequestId: null,
  importStatus: null
};

const beneficiariesImportSlice = createSlice({
  name: 'beneficiariesImport',
  initialState,
  reducers: {
    setImportStatus: (
      state,
      { payload }: PayloadAction<ImportStatusResponse>
    ) => {
      state.importStatus = payload;
    }
  }
});

export const { reducer, actions: beneficiariesImportActions } =
  beneficiariesImportSlice;
